import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import FeaturesSection from '../components/FeaturesSection';
import HowItWorks from '../components/HowItWorks';
import CreditSystem from '../components/CreditSystem';
import PricingSection from '../components/PricingSection';
import TestimonialsSection from '../components/TestimonialsSection';
import FAQSection from '../components/FAQSection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import AuthModal from '../components/AuthModal';
import { Toaster } from '../components/ui/sonner';

export default function LandingPage() {
  const navigate = useNavigate();
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState('signup');

  const openSignup  = () => { setAuthMode('signup');  setAuthOpen(true); };
  const openSignin  = () => { setAuthMode('signin');  setAuthOpen(true); };
  // Paid plan clicked while logged in → go to dashboard upgrade tab
  const openPayment = () => navigate('/dashboard?upgrade=true');

  return (
    <div className='min-h-screen bg-background'>
      <Navbar onGetStarted={openSignup} onSignIn={openSignin} />
      <HeroSection onGetStarted={openSignup} />
      <FeaturesSection />
      <HowItWorks />
      <CreditSystem onGetStarted={openSignup} />
      <PricingSection onSelectPlan={openPayment} onGetStarted={openSignup} onSignIn={openSignin} />
      <TestimonialsSection />
      <FAQSection />
      <CTASection onGetStarted={openSignup} />
      <Footer onGetStarted={openSignup} onSignIn={openSignin} />
      <AuthModal
        open={authOpen}
        onOpenChange={setAuthOpen}
        mode={authMode}
        onModeChange={setAuthMode}
      />
      <Toaster position='top-right' richColors />
    </div>
  );
}
